<template>
  <div class="schoolRoadTeamPackageadd">
    <div class="header">
      <el-button size="medium" @click="$router.go(-1)">返回</el-button>
      <el-button size="medium" type="primary" @click="schoolRoadTeamPackageimglist()">放学卡管理</el-button>
    </div>
    <div class="body" :style="`height: ${windowHeight - 170}px;`">
       <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
           <div class="title">套餐信息</div>
           <el-form-item label="SN" prop="equipmentId">
             {{formData.equipmentId}}
            </el-form-item>
            <el-form-item
              label="设备类型"
              prop="equipType"
            >
            {{formData.equipTypeName}}
            </el-form-item>
            <el-form-item
              label="使用场景"
              prop="useType"
            >
              {{formData.useTypeName}}
              </el-select>
               </el-form-item>
            <el-form-item label="学校类型" >
                {{formData.schoolType==2?"小学":"初中"}}
            </el-form-item>
            <el-form-item label="年级数量" >
               {{formData.gradeCount}}
            </el-form-item>
             <el-form-item label="班级轨数" >
              {{formData.classCount}}
            </el-form-item>
             <el-form-item label="放学卡数量" >
              {{formData.cardCount}}
            </el-form-item>
             <el-form-item label="状态" >
              <el-tag  size="mini" type="info" v-if="formData.state==1">未使用</el-tag>
                    <el-tag  size="mini" type="success" v-if="formData.state==2">已发货</el-tag>
                    <el-tag  size="mini"  v-if="formData.state==3">已使用</el-tag>
            </el-form-item>
             <div class="title">发货信息</div>
             <el-form-item label="发货人">
              {{formData.consignorUserName||"----"}}
            </el-form-item>
            <el-form-item label="发货时间" >
              {{formData.consignorTime?formData.consignorTime.substring(0, 19):"----"}}
            </el-form-item>
             <el-form-item label="发货单号" >
              {{formData.consignorNum||"----"}}
            </el-form-item>
             <el-form-item label="发货备注" >
              {{formData.consignorRemark||"----"}}
            </el-form-item>
             <div class="title">绑定信息</div>
             <el-form-item label="绑定学校">
              {{formData.schoolName||"----"}}
            </el-form-item>
            <el-form-item label="绑定时间" >
             {{formData.bindTime?formData.bindTime.substring(0, 19):"----"}}
            </el-form-item>
           </el-form>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {findDicsByCode} from '@/api/common/common';
  import {updateSchooloverCombo,getSchooloverCombo} from '@/api/schoolRoadTeamPackage';
  export default {
    data() {
     
      return {        
        formData: {
            cardCount:0,//	放学卡数量	number	
            classCount:4,//		班级数	number	           	
            equipmentId:"",//	设备id （序列号）	string	
            gradeCount:5,//		年级数	number	
            schoolType:2,//	学校类型	number	
            state:1,//		状太1未使作，2已发货，3已使用	number	
            equipType:"",//	设备类型	number	
            equipTypeName:"",//	设备类型名称	string
            useType:"",//	使用类型	number	
            useTypeName:"",//		使用类型名称	string	
            consignorUserName:"",
            consignorRemark:"",
            consignorTime:"",
            consignorNum:"",
        }      
      }
    },
    mixins: [windowResize],
    created() {
        getSchooloverCombo(this.$route.query.id)
        .then((res) => {
          const data = res.data.data;
          if (res.data.code === 200) {
              this.formData=data;
          }
        })
        .catch();
         
    },
    methods: {
        schoolRoadTeamPackageimglist(){
                this.$router.push({
                    path: "schoolRoadTeamPackageimglist",
                     query:{
                        id:this.$route.query.id
                    }
                });
            }, 
     
    }
  }
</script>
<style lang="scss" scoped>
  .schoolRoadTeamPackageadd{
    padding: 12px;
    *{
        box-sizing: border-box;
    }
    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }
    .body{
     overflow: auto;
     .demo-ruleForm{
         margin: 10px auto;
         width: 810px;
         .title{
             height: 20px;
            line-height: 20px;
            margin: 10px 0;
            padding-left: 8px;
            border-left: 4px solid #409eff;
            color: #333;
         }
         .el-form-item{
                 margin-bottom: 2px;
         }
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/schoolRoadTeamPackage/schoolRoadTeamPackageinfo.vue